var Marionette = require('backbone.marionette');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');
var actionsChannel = Radio.channel('actions');

var CommonUtils = require('../../utils/common-utils.js');
var Constants = require('../../utils/constants');

var ExportDocumentForm = Marionette.View.extend({
    template: require('../../templates/documents/export-document-form.html'),

    ui: {
        modal: '#export-modal',
        exportType: "#export-type",

        exportDocument: '#export-document',
        exportDocumentConfirm: '#export-document-confirm',
        exportFormBody: '#export-form-body',
        exportConfirmationBody: '#export-confirmation-body',
        exportFooter: '#export-footer',
        confirmationFooter: '#confirmation-footer'
    },

    events: {
        'click @ui.exportDocument': 'onExport',
        'click @ui.exportDocumentConfirm': 'onExportNoConfirm',
        'change @ui.exportType': 'onChangeExportType'
    },

    initialize: function (options) {

        var that = this;
        that.utils = new CommonUtils();
        that.allFiltered = options.allFiltered || false;
        that.params = options.params || "";
        that.url = '/api/document/export?' + that.params;
        that.documentsExport = {
            exportType: "csv",
            documentIds: options.docIds,
            userTimezoneOffsetInHours: new Date().getTimezoneOffset() / 60
        }
        that.docsCount = options.docsCount || 0;
        that.docsCount = that.allFiltered ? that.docsCount : (that.documentsExport.documentIds || []).length;
    },

    templateContext: function () {
        var that = this;
        return {
            docsCount: that.docsCount
        }
    },

    onRender: function () {
        var that = this;
        this.show();
    },

    onExport: function () {
        var that = this;
        if ((that.documentsExport.documentIds == [] || _.isEmpty(that.documentsExport.documentIds) || _.isEmpty(that.documentsExport.exportType)) && !that.allFiltered)
            return;

        if (that.docsCount > Constants.pageCapacity) {
            that.ui.exportFormBody.hide();
            that.ui.exportFooter.hide();
            that.ui.exportConfirmationBody.show();
            that.ui.confirmationFooter.show();
        } else {
            that.onExportNoConfirm();
        }
    },

    onExportNoConfirm: function () {
        var that = this;

        var form = document.createElement('form');
        form.setAttribute('target', '_blank');
        form.setAttribute('action', that.url);
        form.setAttribute('method', 'post');
        document.body.appendChild(form);

        var input = document.createElement('input');
        input.setAttribute('type', 'text');
        input.setAttribute('name', "exportType");
        input.setAttribute('value', decodeURIComponent(that.documentsExport.exportType));
        form.appendChild(input);

        var input2 = document.createElement('input');
        input2.setAttribute('type', 'text');
        input2.setAttribute('name', "documentIds");
        input2.setAttribute('value', decodeURIComponent(that.documentsExport.documentIds.join(",")));
        form.appendChild(input2);

        var input3 = document.createElement('input');
        input3.setAttribute('type', 'text');
        input3.setAttribute('name', "userTimezoneOffsetInHours");
        input3.setAttribute('value', decodeURIComponent(that.documentsExport.userTimezoneOffsetInHours));
        form.appendChild(input3);

        form.submit();

        window.setTimeout(function () {
            document.body.removeChild(form);
            that.hide();
        }, 0);

    },

    show: function () {
        this.ui.modal.modal({backdrop: 'static', keyboard: false});
    },

    hide: function () {
        this.ui.modal.modal('hide');
    },

    onChangeExportType: function (e) {
        this.documentsExport.exportType = e.target.value;
    },

});

module.exports = ExportDocumentForm;


//////////////////
// WEBPACK FOOTER
// ./app/views/documents/export-document-form.js
// module id = 330
// module chunks = 0